var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTouchTripleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.475 22q-.7 0-1.312-.3t-1.038-.85l-5.45-6.925l.475-.5q.5-.525 1.2-.625t1.3.275L7.5 14.2V6q0-.425.288-.712T8.5 5t.725.288t.3.712v11.8L7.1 16.3l2.6 3.325q.15.175.35.275t.425.1H16q.825 0 1.413-.587T18 18v-4q0-.425-.288-.712T17 13h-5.475v-2H17q1.25 0 2.125.875T20 14v4q0 1.65-1.175 2.825T16 22zm-6.3-13.5q-.325-.55-.5-1.187T3.5 6q0-2.075 1.463-3.537T8.5 1q.675 0 1.3.163t1.175.487q1.175.65 1.85 1.825T13.5 6q0 .675-.175 1.313t-.5 1.187l-1.725-1q.2-.35.3-.712T11.5 6q0-.8-.412-1.5T9.975 3.4q-.325-.2-.7-.3T8.5 3q-1.25 0-2.125.875T5.5 6q0 .425.1.788t.3.712zm13.8-5.1l1-1.75q1.175.65 1.85 1.825T21.5 6q0 .675-.175 1.313t-.5 1.187l-1.725-1q.2-.35.3-.712T19.5 6q0-.8-.412-1.5t-1.113-1.1m-4 0l1-1.75q1.175.65 1.85 1.825T17.5 6q0 .675-.175 1.313t-.5 1.187l-1.725-1q.2-.35.3-.712T15.5 6q0-.8-.413-1.5t-1.112-1.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchTripleOutline);
export default __webpack_public_path__ + "static/media/touch-triple-outline.628b992116b0ee82cdb7825c701668a6.svg";
export { ForwardRef as ReactComponent };